window.$ = window.jQuery = require('jquery');

require('bootstrap');
//require('owl.carousel');
require('jquery-slimscroll');
require('select2');
require('select2/dist/js/i18n/pt-BR');
//require('bootstrap-select');
//require('bootstrap-touchspin');
//require('multiselect');
require('bootstrap-switch');
require('jquery-toast-plugin');
require('sweetalert');
//require('inputmask/dist/jquery.inputmask.bundle');
require('inputmask/dist/inputmask.es6');
//require('bootstrap-datepicker');
//require('../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt-BR.min');
//require ('jquery-mask-plugin');//REMOVER

require('./vendor/form-advance-data');
//require('./vendor/dropdown-bootstrap-extended');
require('./vendor/init');

require('./servico/desinstalacao/carregarRastreadorRastreavel');
require('./componentes/popularSelectModelosRastreador');
require('./componentes/autoCompleteCliente');
require('./componentes/popularSelectRastreavel');
require('./componentes/popularSelectUsuario');
require('./componentes/notificacao');
require('./componentes/mascaras');
require('./componentes/avisoDeletarRegistro');
require('./componentes/ocultarExibirFiltro');
require('./conta/cliente/usuario/executar');
require('./conta/usuario/executar');
require('./rastreavel/rastreavel/executar');
require('./rastreavel/expediente/executar');
require('./rastreavel/album/executar');
require('./rastreador/enviarComando/executar');
require('./notificacao/permissoesRecebimento/executar');
require('./cerca/executar');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken   = true;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}
